import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import styled from "styled-components";
import { BOTTOM_WIDGET_HEIGHT } from "./constant";

export const Container = styled.div(({ theme }) => ({
    width: "100%",
    maxWidth: "100%",
    display: "flex",
    flexDirection: "column",
    position: "relative",
    height: "100%",
    overflowX: "hidden",
    background:
        theme.colorMode === "light"
            ? theme.colors[theme.colorMode].background_Secondary
            : theme.colors.dark.canvas_Primary,
}));

export const FlexContainer = styled.div({
    flexGrow: 1,
    overflowY: "scroll",
    overflowX: "hidden",
    width: "100%",
    maxWidth: "100%",
});

export const BottomWidget = styled.div<{ $height?: number }>(({ $height }) => ({
    height: $height ?? BOTTOM_WIDGET_HEIGHT.BASE,
    width: "100%",
    flexShrink: 0,
}));

export const OverLayLoader = styled("div")(({ theme }) => ({
    width: "100vw",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: theme.colors[theme.colorMode].canvas_Primary,
}));

export const ErrorPageWrapper = styled.div({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
});

export const ErrorContainer = styled.div({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    textAlign: "center",
    maxWidth: "320px",
});

export const PendingAndErrorHeaderContainer = styled.div(({ theme }) => ({
    height: 50,
    minHeight: 50,
    position: "sticky",
    background:
        theme.colorMode === "light"
            ? theme.colors[theme.colorMode].background_Primary
            : theme.colors.dark.background_Tertiary,
    top: 0,
    zIndex: 1,
    width: "100%",
    padding: theme.spacing.medium,
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: -1,
}));

export const BackIconWrapper = styled.div(({ theme }) => ({
    position: "absolute",
    left: theme.spacing.medium,
    height: "100%",
    display: "flex",
    alignItems: "center",
}));

export const Separator = styled.div(({ theme }) => ({
    borderTop: `1px dashed ${theme.colors[theme.colorMode].divider}`,
    width: "100%",
    marginTop: theme.spacing.xSmall,
}));

export const SeparatorText = styled(Text)(({ theme }) => ({
    textAlign: "center",
    margin: `${theme.spacing.small} ${theme.spacing.medium} ${theme.spacing.medium}`,
}));

export const SeparatorButtonText = styled(Text)(({ theme }) => ({
    margin: `0 ${theme.spacing.medium}`,
}));
